import Collect from './Collect.vue'
export default Collect



// WEBPACK FOOTER //
// ./src/pages/Collect/index.js